// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_TaxCategory } from '../../store/Lookup/lookupSlice';

const useGetTaxCategory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (TaxCategory.length === 0) {
      dispatch(Get_TaxCategory());
    }
  }, []);

  const { TaxCategory, loading, error } = useSelector(state => state.Lookup);

  return { TaxCategory, loading, error };
};

export default useGetTaxCategory;
